import React from 'react'

const Stats = ({ nbHits }) => (
  <div className="stats">{nbHits} Activités trouvées</div>
)

export default Stats
